import { Card } from "../Card";
import "./Styles/styles.css";

export const List = ({
  listTransactions,
  arrFiltered,
  setListTransactions,
  setFilterValue,
}) => {
  return (
    <aside className="list-container">
      <div className="list-header">
        <h1>Resumo financeiro</h1>
        <div className="list-button">
          <button onClick={() => setFilterValue("todos")} className="list-btn">
            Todos
          </button>
          <button
            onClick={() => setFilterValue("entrada")}
            className="list-btn"
          >
            Entradas
          </button>
          <button onClick={() => setFilterValue("saida")} className="list-btn">
            Despesas
          </button>
        </div>
      </div>
      <div>
        <ul>
          {arrFiltered.map((transaction, index) => (
            <Card
              listTransactions={listTransactions}
              setListTransactions={setListTransactions}
              transaction={transaction}
              key={index}
            />
          ))}
        </ul>
      </div>
    </aside>
  );
};
